import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1072ZpModulStatus: 'idle',
    startProcess1072ZpModulError: undefined as any,
    loadUserParamsProcess1072ZpModulStatus: 'idle',
    loadUserParamsProcess1072ZpModulError: undefined as any,

    process1072ZpModulList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1072ZpModul = createAsyncThunk('process1072ZpModulSlice/startProcess1072ZpModul', async ({ process1072ZpModul }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1072ZpModul/`,
        prepareData(process1072ZpModul),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1072ZpModulStatus } = getState().process1072ZpModulSlice
        return startProcess1072ZpModulStatus !== 'pending'
    }
})

export const loadUserParamsProcess1072ZpModul = createAsyncThunk('process1072ZpModulSlice/loadUserParamsProcess1072ZpModul', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1072ZpModul/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1072ZpModulStatus } = getState().process1072ZpModulSlice
        return loadUserParamsProcess1072ZpModulStatus !== 'pending'
    }
})

const Process1072ZpModulSlice = createSlice({
    name: 'process1072ZpModulSlice',
    initialState,
    reducers: {
        resetstartProcess1072ZpModul: (state) => {
            state.job = undefined
            state.startProcess1072ZpModulError = undefined
        },
        resetstartProcess1072ZpModulError: (state) => {
            state.startProcess1072ZpModulError = undefined
        },
        resetloadUserParamsProcess1072ZpModul: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1072ZpModulError = undefined
        },
        resetloadUserParamsProcess1072ZpModulError: (state) => {
            state.loadUserParamsProcess1072ZpModulError = undefined
        },
        removeFromProcess1072ZpModulListById: (state, action) => {
            state.process1072ZpModulList = state.process1072ZpModulList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1072ZpModulListByIds: (state, action) => {
            state.process1072ZpModulList = state.process1072ZpModulList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1072ZpModulList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1072ZpModulStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1072ZpModulList = []
            state.startProcess1072ZpModulStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1072ZpModul.pending, (state) => {
            state.startProcess1072ZpModulStatus = 'pending'
            state.startProcess1072ZpModulError = undefined
        })
        builder.addCase(startProcess1072ZpModul.fulfilled, (state, action) => {
            state.startProcess1072ZpModulStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1072ZpModul.rejected, (state, action) => {
            state.startProcess1072ZpModulStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1072ZpModulError = action.error.message
            } else {
                state.startProcess1072ZpModulError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1072ZpModul.pending, (state) => {
            state.loadUserParamsProcess1072ZpModulStatus = 'pending'
            state.loadUserParamsProcess1072ZpModulError = undefined
        })
        builder.addCase(loadUserParamsProcess1072ZpModul.fulfilled, (state, action) => {
            state.loadUserParamsProcess1072ZpModulStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1072ZpModul.rejected, (state, action) => {
            state.loadUserParamsProcess1072ZpModulStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1072ZpModulError = action.error.message
            } else {
                state.loadUserParamsProcess1072ZpModulError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1072ZpModul,
    resetstartProcess1072ZpModulError,
    resetloadUserParamsProcess1072ZpModul,
    resetloadUserParamsProcess1072ZpModulError,
    removeFromProcess1072ZpModulListById,
    removeFromProcess1072ZpModulListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1072ZpModulSlice.actions
export default Process1072ZpModulSlice.reducer
